<template>
	<div>
		<v-card>
			<v-card-title>
				<h1>Lieferauftrag für Auftrag {{ order.orderId }}</h1>
			</v-card-title>
			<v-card-text>
				<h2 class="title">
					Berechnetes Gebinde: Gewicht:
					<span v-if="order.weight > order.weightOfParts">
						{{ order.weight | formatDigit }} kg
					</span>
					<span v-else> {{ order.weightOfParts | formatDigit }} kg </span>
					LxBxH: {{ (order.length / 10) | formatInteger }} x
					{{ (order.width / 10) | formatInteger }} x
					{{ (order.height / 10) | formatInteger }} cm
				</h2>
				<v-progress-linear
					v-show="dataLoading"
					color="accent"
					indeterminate
				></v-progress-linear>
				<v-container
					fluid
					v-bind="{ [`grid-list-md`]: true }"
					style="background-color: white"
				>
					<v-layout row wrap align-end="true">
						<v-flex xs12 sm6 md4 v-for="(gebinde, index) in gebindes" :key="gebinde.id">
							<gebinde-component
								@validChanged="validate()"
								:gebinde="gebinde"
								:weightOfParts="order.weightOfParts"
								:index="index + 1"
								:isLkw="isLkw"
								:maxWeightPerContainer="maxWeightPerContainer"
								v-on:deletedGebinde="deleteGebinde($event)"
							>
							</gebinde-component>
						</v-flex>
						<v-btn @click="addGebinde()">
							<v-icon class="mr-1">add</v-icon>
							Zusatzgebinde
						</v-btn>
					</v-layout>
				</v-container>
				<v-checkbox
					v-model="comparePrice"
					v-if="canManuallyTransmit"
					label="Preis vor Auftrag prüfen"
				>
				</v-checkbox>
			</v-card-text>
			<v-card-actions>
				<v-btn flat @click="$emit('closed')">Schliessen</v-btn>
				<v-btn :disabled="!isValid" @click="openConfirmation()" class="blexon-button" flat
					>Weiter</v-btn
				>
			</v-card-actions>
		</v-card>

		<v-dialog v-model="dialog" width="500">
			<v-card>
				<v-card-title class="headline grey lighten-2" primary-title>
					Transportauftrag bestätigen
				</v-card-title>
				<v-card-text>
					Wenn Sie auf 'OK' klicken, wird automatisch ein Transportauftrag ausgelöst. Eine
					Änderung der Gebinde ist dann nicht mehr möglich.<br />
					{{ gebindes.length }} Gebinde
					<ul>
						<li v-for="gebinde in gebindes" v-bind:key="gebinde.id">
							{{ gebinde.weight }} kg | {{ gebinde.length }} x {{ gebinde.width }} x
							{{ gebinde.height }} cm
						</li>
					</ul>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="blexon-button" flat @click="dialog = false">Abbrechen</v-btn>
					<v-btn class="blexon-button" flat @click="saveGebinde()">OK</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import GebindeComponent from "./gebindeComponent";

export default {
	components: {
		"gebinde-component": GebindeComponent,
	},
	props: {
		order: null,
	},
	data() {
		return {
			dialog: false,
			gebindes: [],
			dataLoading: false,
			isValid: false,
			comparePrice: true,
		};
	},
	mounted() {
		this.validate();
	},
	watch: {
		order() {
			if (this.order !== null) {
				this.loadGebinde();
			}
		},
	},
	computed: {
		canManuallyTransmit() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canManuallyTransmit;
		},
		isLkw() {
			if (!this.orderTransportProvider) {
				return false;
			}
			return this.orderTransportProvider.isLkw;
		},
		orderTransportProvider() {
			return this.$store.state.transportProviders.find(
				(t) => t.id == this.order.transportProviderId
			);
		},
		maxWeightPerContainer() {
			if (!this.orderTransportProvider) {
				return 30;
			}
			return this.orderTransportProvider.weightLimit;
		},
	},
	methods: {
		getGebindeDetailsOfTransportProvider() {
			if (!this.orderTransportProvider) {
				return false;
			}
			return this.orderTransportProvider.gebindeDetailDefinition;
		},
		addGebinde() {
			var gebinde = {
				gebindeDetailDefinition: this.getGebindeDetailsOfTransportProvider(),
				weight: 0,
				timeEffort: 0,
				length: 0,
				width: 0,
				height: 0,
				numberOfEuropalettes: 0,
				numberOfEuropalettesFrames: 0,
				numberOfEuropalettesLid: 0,
				blexonCustomerOrderId: this.order.orderId,
			};
			this.gebindes.push(gebinde);
		},

		deleteGebinde(index) {
			this.gebindes.splice(index, 1);
		},

		validate() {
			this.isValid = !this.gebindes.some((g) => g.valid === false);
		},

		/**
		 * Checks if all inputs are valid and opens
		 * the dialog to confirm the transport
		 */
		openConfirmation() {
			if (!this.isValid) {
				console.log("Hat noch Fehler");
			} else {
				this.dialog = true;
			}
		},

		async saveGebinde() {
			if (!this.isValid) {
				console.log("Hat noch Fehler");
			} else {
				try {
					this.dataLoading = true;
					var response = await httpClient().post(
						`api/Production/SaveGebindes?orderId=${this.order.orderId}`,
						this.gebindes
					);
					this.gebindes = response.data; // with id
					this.$emit("saved", this.comparePrice);
				} catch (err) {
					console.log(err);
				} finally {
					this.dataLoading = false;
				}
			}
		},

		async loadGebinde() {
			try {
				this.dataLoading = true;
				var response = await httpClient().get(
					`api/Production/GetGebindes?orderId=` + this.order.orderId
				);
				this.gebindes = response.data;
				var gebindeDetailDefinition = this.getGebindeDetailsOfTransportProvider();
				// round the dimensions to the nearest integer (cm) for validation reasons
				// using the floor so that the preconfigured container sizes are not exceded
				this.gebindes.forEach((gebinde) => {
					gebinde.gebindeDetailDefinition = gebindeDetailDefinition;
					gebinde.length = Math.floor(gebinde.length);
					gebinde.width = Math.floor(gebinde.width);
					gebinde.height = Math.floor(gebinde.height);
				});
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
	},
};
</script>
